import React from "react";
import moment from "moment/min/moment-with-locales";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { SplitButton } from "primereact/splitbutton";
import { ServiceLogin } from "../../service/Login";

import calendar from "../../images/Icons/calendar.svg";
import hospital from "../../images/Icons/lucide_hospital.svg";
import doctor from "../../images/Icons/hugeicons_doctor.svg";
import downloadImg from "../../images/Icons/Download-image.svg";
import downloadDicomZip from "../../images/Icons/Icone-DicomZip.svg";
import keyImg from "../../images/Icons/key.svg";
import share from "../../images/Icons/Share-icon.svg";
import printIcon from "../../images/Icons/Print-icon.svg";
import iconeProntuario from "../../images/Icons/iconeProntuario.svg";
import iconeAmpulheta from "../../images/Icons/icone-ampulheta.svg";
import iconeCorreto from "../../images/Icons/icone-correto.svg";

import viewerIcon_principal from "../../images/Icons/icone-viewer-branco.svg";
import galeryIcon_principal from "../../images/Icons/image_dashboard_white.svg";
import viewerIcon_secundario from "../../images/Icons/icone-viewer-azul.svg";
import galeryIcon_secundario from "../../images/Icons/mage_dashboard.svg";

import "./StudyCard.css";

const StudyCard = ({ pedido, parent }) => {
    let dataEstudo = "";
    let btnLaudoDisabled = false;
    let btnImageDisable = false;
    let btnGaleriaDisable = false;
    let btnAnexoDisabled = false;
    let msgLaudo = "";
    let btnLaudoDisabledSemServico = false;
    let btnImagemDisabledSemServico = false;
    let titleBtnLaudoDisabledSemServico = "";
    let titleBtnImageDisabledSemServico = "";
    let temStl = pedido.temStl;

    try {
        dataEstudo = new Date(pedido.DataEstudo);
        dataEstudo = moment(dataEstudo).format("DD/MM/YYYY");
        btnAnexoDisabled = parent.DesabilitarBtnAnexo(pedido);
        btnLaudoDisabledSemServico = parent.DesabilitarBtnLaudoSemServico(pedido);
        btnLaudoDisabled = parent.state.isMedico & btnLaudoDisabledSemServico ? btnLaudoDisabledSemServico : parent.DesabilitarBtnLaudo(pedido);
        btnImagemDisabledSemServico = parent.DesabilitarBtnImagemSemServico(pedido);
        btnImageDisable = parent.state.btnImageDisable;
        msgLaudo = parent.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);
        titleBtnLaudoDisabledSemServico = parent.state.isMedico & btnLaudoDisabledSemServico ? "Pedido não possui serviço vinculado" : "";
        titleBtnImageDisabledSemServico = parent.state.isMedico & btnImagemDisabledSemServico ? "Pedido não possui serviço vinculado" : "";

        if (pedido.StudyUid != null && pedido.StudyUid !== "" || pedido.possuiJob !== false) {
            btnImageDisable = false;
        } else {
            btnImageDisable = true;
        }

        if (pedido.possuiJob !== false || pedido.StudyUid != null && pedido.StudyUid !== "") {
            btnGaleriaDisable = false;
        } else {
            btnGaleriaDisable = true;
        }
    } catch (ex) {
        console.log(ex);
    }

    const {
        isMedico,
        isExecutante,
        acaoPrincipalBotaoImagensMedico,
        acaoPrincipalBotaoImagensPaciente,
        acaoPrincipalThumbnailImagensMedico,
        acaoPrincipalThumbnailImagensPaciente
    } = parent.state;

    const isPerfilMedico = isMedico || isExecutante;

    const acaoPrincipal = isPerfilMedico
        ? acaoPrincipalBotaoImagensMedico
        : acaoPrincipalBotaoImagensPaciente;

    const acaoPrincipalPreview = isPerfilMedico
        ? acaoPrincipalThumbnailImagensMedico
        : acaoPrincipalThumbnailImagensPaciente;

    const labelAcaoPrincipal =
        acaoPrincipal === "Viewer"
            ? (parent.state.labelBotaoViewer || "Abrir Viewer")
            : (parent.state.labelBotaoGaleria || "Galeria de imagens");

    const acaoSecundaria = acaoPrincipal === "Viewer" ? "Galeria" : "Viewer";

    const iconPrincipal =
        acaoPrincipal === "Viewer"
            ? <img className="btnPrincipalImagens" src={viewerIcon_principal} alt="Viewer" style={{ width: "30px", height: "30px", marginRight: "8px" }} />
            : <img className="btnPrincipalImagens" src={galeryIcon_principal} alt="Galeria" style={{ width: "30px", height: "30px", marginRight: "8px" }} />;

    const iconSecundario =
        acaoSecundaria === "Viewer"
            ? <img src={viewerIcon_secundario} alt="Viewer" style={{ width: "20px", height: "20px", marginRight: "8px" }} />
            : <img src={galeryIcon_secundario} alt="Galeria" style={{ width: "20px", height: "20px", marginRight: "8px" }} />;

    const mostrarBotaoImagens = isPerfilMedico
        ? (parent.state.botaoViewerAtivoMedico || parent.state.botaoGaleriaAtivoMedico)
        : (parent.state.botaoViewerAtivoPaciente || parent.state.botaoGaleriaAtivoPaciente);

    const hasOptions = (() => {
        if (isPerfilMedico) {
            const {
                botaoGaleriaAtivoMedico,
                botaoViewerAtivoMedico,
                acaoBaixarImagens_visualizador_Medico,
                acaoBaixarImagens_dicomZip_Medico
            } = parent.state;

            const variasOpcoesDeImagem = botaoGaleriaAtivoMedico && botaoViewerAtivoMedico;
            const opcoesDeDownload = acaoBaixarImagens_visualizador_Medico || acaoBaixarImagens_dicomZip_Medico;

            return variasOpcoesDeImagem || opcoesDeDownload;
        }

        const {
            botaoGaleriaAtivoPaciente,
            botaoViewerAtivoPaciente,
            acaoBaixarImagens_visualizador_Paciente,
            acaoBaixarImagens_dicomZip_Paciente
        } = parent.state;

        const variasOpcoesDeImagem = botaoGaleriaAtivoPaciente && botaoViewerAtivoPaciente;
        const opcoesDeDownload = acaoBaixarImagens_visualizador_Paciente || acaoBaixarImagens_dicomZip_Paciente;

        return variasOpcoesDeImagem || opcoesDeDownload;
    })();

    const hasLaudoExtras = isPerfilMedico
        ? (parent.state.botaoImprimirLaudoAtivoMedico || parent.state.botaoCompartilharAtivoMedico)
        : (parent.state.botaoImprimirLaudoAtivoPaciente || parent.state.botaoCompartilharAtivoPaciente);

    const perfil = parent.RetPerfil();
    const isConvenioPerfil = perfil === "Convênio";
    const isSharedProfile = parent.state.isAcessoCompartilhado;

    const renderStatusMedico = () => (
        <>
            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusProcessamentoMedico} </b>
                </div>
            </div>

            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && !btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusAguardandoMedico} </b>
                </div>
            </div>

            <div className="statusArea-green" style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusLiberadoMedico} </b>
                </div>
            </div>
        </>
    );

    const renderStatusPaciente = () => (
        <>
            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusProcessamentoPaciente} </b>
                </div>
            </div>

            <div className="statusArea-yellow" style={{ display: (btnLaudoDisabled && !btnImageDisable) ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusAguardandoPaciente} </b>
                </div>
            </div>

            <div className="statusArea-green" style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                    <b> {parent.state.labelStatusLiberadoPaciente} </b>
                </div>
            </div>
        </>
    );

    const renderMedicoOuConvenioProfile = () => (
        <>
            <div className="card-details">
                <div className="PacienteDados">
                    <div className="PacienteDados-Nome-Prontuario-status-desktop">
                        <div className="PacienteDados-Nome">
                            <b>{pedido.Paciente.Nome}</b>
                        </div>

                        {(parent.state.infoProntuarioAtivoMedico) && (
                            <div style={{ display: "flex" }}>
                                <div className="PacienteDados-icone">
                                    <b> | </b>
                                    <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                </div>

                                <div className="PacienteDados-Prontuario">
                                    <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                </div>
                            </div>
                        )}

                        {(parent.state.statusAtivoMedico) && (<div>{renderStatusMedico()}</div>)}
                    </div>

                    <div className="PacienteDados-celular">
                        <div className="PacienteDados-Nome-Prontuario">
                            {!parent.state.isAcessoCompartilhado && (
                                <div className="PacienteDados-Nome">
                                    <b>{pedido.Paciente.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoProntuarioAtivoMedico) && (
                                <div style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                        <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                    </div>

                                    {!parent.state.isAcessoCompartilhado && (
                                        <div className="PacienteDados-Prontuario">
                                            <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Exame-Status">
                            <div className={"ExameTituloMedico"}>
                                <b>
                                    {pedido.Procedimento.Modalidade.Abreviacao} - {" "}
                                    {pedido.Procedimento.Nome}
                                </b>
                            </div>

                            {(parent.state.statusAtivoMedico) && (
                                <div>{renderStatusMedico()}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-details">
                <div className="card-details-zone">
                    <div className="card-details-left">
                        <div className="PacienteDados-Nome-Prontuario-status-tablet">
                            <div className="PacienteDados-Nome">
                                <b>{pedido.Paciente.Nome}</b>
                            </div>

                            {(parent.state.infoProntuarioAtivoMedico) && (
                                <div className="PacienteDados-icone-prontuario" style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                    </div>

                                    <div className="PacienteDados-Prontuario">
                                        <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                    </div>
                                </div>
                            )}

                            {(parent.state.statusAtivoMedico) && (
                                <div className="statusArea-medico">{renderStatusMedico()}</div>
                            )}
                        </div>

                        <div className="PacienteDados-Exame-Data-Acnumber-Desktop">
                            <div className={"ExameTituloMedico-desktop"}>
                                <b>
                                    {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                    {pedido.Procedimento.Nome}
                                </b>
                            </div>

                            {(parent.state.infoDataAtivoMedico) && (
                                <div className="DataExameMedico">
                                    <img src={calendar} style={{ width: "20px", height: "20px" }} />
                                    <div>
                                        {parent.state.labelInfoData || "Data"} <b>{dataEstudo}</b>
                                    </div>
                                </div>
                            )}

                            {(parent.state.infoAcNumberAtivoMedico) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                                <div className="AcNumber">
                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                    {parent.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Data-Acnumber">
                            {(parent.state.infoDataAtivoMedico) && (
                                <div className="DataExameMedico">
                                    <img src={calendar} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                    {parent.state.labelInfoData || "Data"} <b>{" " + dataEstudo}</b>
                                </div>
                            )}

                            {(parent.state.infoAcNumberAtivoMedico) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                                <div className="AcNumber">
                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                    {parent.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                </div>
                            )}
                        </div>

                        <div className="PacienteDados-Info">
                            <br></br>
                            {(parent.state.infoUnidadeAtivoMedico) && (
                                <div className="Unidade">
                                    <img src={hospital} style={{ marginRight: "5px" }} />
                                    {parent.state.labelInfoUnidade || "Unidade"}  <b>{pedido.Unidade.Nome}</b>
                                </div>
                            )}

                            {parent.state.infoMedSolicitanteAtivoMedico && pedido.MedicoSolicitante?.Nome && pedido.MedicoSolicitante.Nome.trim() !== "" && (
                                <div className="MedicoSolicitante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {parent.state.labelInfoMedSolicitante || "Médico Solicitante"} <b>{pedido.MedicoSolicitante.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoMedExecutanteAtivoMedico) && pedido.MedicoExecutante?.Nome && pedido.MedicoExecutante.Nome.trim() !== "" && (
                                <div className="MedicoExecutante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {parent.state.labelInfoMedExecutante || "Médico Executante"}  <b>{pedido.MedicoExecutante.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoMedRevisorAtivoMedico) && pedido.MedicoRevisor?.Nome && pedido.MedicoRevisor.Nome.trim() !== "" && (
                                <div className="MedicoRevisor">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {parent.state.labelInfoMedRevisor || "Médico Revisor"}  <b>{pedido.MedicoRevisor.Nome}</b>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const renderPacienteBase = (mostrarNomePaciente) => (
        <>
            <div className={"ExameTitulo"}>
                {mostrarNomePaciente && (
                    <div className="PacienteDados-Nome" style={{ fontSize: "20px", marginBottom: "10px" }}>
                        <b>{pedido.Paciente.Nome}</b>
                    </div>
                )}

                <div className={"PacienteProcedimentoStatusDados"} style={{ display: "flex" }}>
                    <div className={"PacienteProcedimentoDados"}>
                        <div style={{ display: "flex" }}>
                            <b className={"PacienteProcedimentoTitulo"}>
                                {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                {pedido.Procedimento.Nome}
                            </b>

                            {(parent.state.infoProntuarioAtivoPaciente) && (
                                <div className="PacienteDados-icone-prontuario" style={{ display: "flex" }}>
                                    <div className="PacienteDados-icone">
                                        <b> | </b>
                                        <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                    </div>

                                    <div className="PacienteDados-Prontuario">
                                        <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {(parent.state.statusAtivoPaciente) && (
                        <div className={"PacienteProcedimentoStatus"}>
                            {renderStatusPaciente()}
                        </div>
                    )}

                    {(parent.state.infoDataAtivoPaciente) && (
                        <div className="DataExame-mobile">
                            <img src={calendar} style={{ marginRight: "5px" }} /> {parent.state.labelInfoData || "Data: "} <b>{dataEstudo}</b>
                        </div>
                    )}
                </div>
            </div>

            <div className="StudyArea-info-5">
                <div className="StudyArea-info-6">
                    {(parent.state.infoDataAtivoPaciente) && (
                        <div className="DataExame">
                            <img src={calendar} style={{ marginRight: "5px" }} /> {parent.state.labelInfoData || "Data: "} <b>{dataEstudo}</b>
                        </div>
                    )}

                    {(parent.state.infoUnidadeAtivoPaciente) && (
                        <div className="Unidade">
                            <img src={hospital} style={{ marginRight: "5px" }} />
                            {parent.state.labelInfoUnidade || "Unidade: "} <b>{pedido.Unidade.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoAcNumberAtivoPaciente) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                        <div className="AcNumber">
                            <img src={keyImg} style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                            {parent.state.labelInfoAcNumber || "Ac.Number"} <b>{pedido.AcNumber}</b>
                        </div>
                    )}
                </div>

                <div><br></br></div>

                <div className="PacienteDados-Info">
                    {(parent.state.infoMedSolicitanteAtivoPaciente) && pedido.MedicoSolicitante?.Nome && pedido.MedicoSolicitante.Nome.trim() !== "" && (
                        <div className="MedicoSolicitante">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {parent.state.labelInfoMedSolicitante || "Médico Solicitante"} <b>{pedido.MedicoSolicitante.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoMedExecutanteAtivoPaciente) && pedido.MedicoExecutante?.Nome && pedido.MedicoExecutante.Nome.trim() !== "" && (
                        <div className="MedicoExecutante">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {parent.state.labelInfoMedExecutante || "Médico Executante"} <b>{pedido.MedicoExecutante.Nome}</b>
                        </div>
                    )}

                    {(parent.state.infoMedRevisorAtivoPaciente) && pedido.MedicoRevisor?.Nome && pedido.MedicoRevisor.Nome.trim() !== "" && (
                        <div className="MedicoRevisor">
                            <img src={doctor} style={{ marginRight: "5px" }} />
                            {parent.state.labelInfoMedRevisor || "Médico Revisor"} <b>{pedido.MedicoRevisor.Nome}</b>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

    const renderPacienteProfile = () => renderPacienteBase(false);
    const renderAcessoCompartilhadoProfile = () => renderPacienteBase(true);
    const renderMedicoProfile = () => renderMedicoOuConvenioProfile();
    const renderConvenioProfile = () => renderMedicoOuConvenioProfile();

    const renderVeterinarioProfile = () => {
        if (!pedido?.Unidade?.Veterinaria) {
            return null;
        }

        return (
            <div>
                <div className="Campos-veterinario">
                    <div className="Tutor">
                        Tutor <b>{pedido.Tutor}</b>
                    </div>
                    <div className="Raca">
                        Raça <b>{pedido.Raca}</b>
                    </div>
                    <div className="Especie">
                        Espécie <b>{pedido.Especie}</b>
                    </div>
                </div>
            </div>
        );
    };

    const renderProfileContent = () => {
        if (isPerfilMedico) {
            return renderMedicoProfile();
        }

        if (isConvenioPerfil) {
            return renderConvenioProfile();
        }

        if (isSharedProfile) {
            return renderAcessoCompartilhadoProfile();
        }

        return renderPacienteProfile();
    };

    return (
        <div className="render-list-item-root">
            <div className="StudyArea">
                <div className="StudyArea-Left" style={{ display: "flex" }}>
                    <div>
                        <div style={{ display: "flex" }}>
                            <div className="StudyArea-info">
                                <div style={{ padding: "10px" }}>
                                    {renderProfileContent()}
                                    {renderVeterinarioProfile()}
                                </div>
                            </div>
                        </div>

                        <div className="StudyArea-Buttons">
                            <div className="BtnImagens-area" style={{ display: btnImageDisable ? "none" : "block" }}>
                                {mostrarBotaoImagens && (
                                    <div className="BtnImagens-area" style={{ display: btnImageDisable ? "none" : "block" }}>
                                        {hasOptions && (pedido.StudyUid) ? (
                                            <SplitButton
                                                className="BtnImagens"
                                                icon={iconPrincipal}
                                                label={labelAcaoPrincipal}
                                                iconpos="right"
                                                appendTo="self"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                disabled={btnImageDisable}
                                                tooltipOptions={{ position: "bottom" }}
                                                model={[
                                                    {
                                                        label: acaoSecundaria === "Galeria"
                                                            ? (parent.state.labelBotaoGaleria || "Galeria de imagens")
                                                            : (parent.state.labelBotaoViewer || "Abrir Viewer"),
                                                        icon: iconSecundario,
                                                        disabled: btnGaleriaDisable,
                                                        visible: (acaoSecundaria === "Viewer" && !pedido.StudyUid) ? false : isPerfilMedico
                                                            ? (parent.state.botaoGaleriaAtivoMedico && parent.state.botaoViewerAtivoMedico)
                                                            : (parent.state.botaoGaleriaAtivoPaciente && parent.state.botaoViewerAtivoPaciente),
                                                        command: () => parent.handleAbrirModalGenerica(pedido, acaoSecundaria)
                                                    },
                                                    {
                                                        label: parent.state.lblbtnDownloadVisualizador || "Baixar visualizador",
                                                        icon: <img src={downloadImg} alt="Baixar Imagens" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        visible: pedido.StudyUid ? isPerfilMedico
                                                            ? parent.state.acaoBaixarImagens_visualizador_Medico
                                                            : parent.state.acaoBaixarImagens_visualizador_Paciente
                                                            : false,
                                                        command: () => parent.handleBaixarImagem(pedido)
                                                    },
                                                    {
                                                        label: parent.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip",
                                                        icon: <img src={downloadDicomZip} alt="Baixar Imagens" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        visible: pedido.StudyUid ? isPerfilMedico
                                                            ? parent.state.acaoBaixarImagens_dicomZip_Medico
                                                            : parent.state.acaoBaixarImagens_dicomZip_Paciente
                                                            : false,
                                                        command: () => parent.handleBaixarDicomZip(pedido)
                                                    }
                                                ]}
                                                title={titleBtnImageDisabledSemServico}
                                            />
                                        ) : (
                                            <Button
                                                className="BtnImagens"
                                                icon={iconPrincipal}
                                                label={labelAcaoPrincipal}
                                                iconPos="right"
                                                onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                disabled={btnImageDisable}
                                                tooltipOptions={{ position: "bottom" }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>

                            <div>
                                <div style={{ display: btnLaudoDisabled ? "none" : "block" }}>
                                    {(isPerfilMedico ? parent.state.botaoLaudoAtivoMedico : parent.state.botaoLaudoAtivoPaciente) ? (
                                        hasLaudoExtras ? (
                                            <SplitButton
                                                className="BtnLaudo"
                                                icon="custom-icon"
                                                label={parent.state.labelBotaoLaudo || "Laudo"}
                                                iconpos="right"
                                                appendTo="self"
                                                onClick={() => {
                                                    const isAndroid = /Android/i.test(navigator.userAgent);
                                                    if (isAndroid) {
                                                        parent.handleAbrirModalGenerica(pedido, "LaudoAndroid");
                                                    } else {
                                                        parent.handleAbrirModalGenerica(pedido, "Laudo");
                                                    }
                                                }}
                                                disabled={btnLaudoDisabled}
                                                tooltipOptions={{ position: "bottom" }}
                                                title={titleBtnLaudoDisabledSemServico}
                                                model={[
                                                    {
                                                        label: parent.state.labelBotaoImprimirLaudo || "Imprimir Laudo",
                                                        icon: <img src={printIcon} alt="Imprimir Laudo" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                        disabled: btnLaudoDisabled,
                                                        visible: isPerfilMedico
                                                            ? parent.state.botaoImprimirLaudoAtivoMedico
                                                            : parent.state.botaoImprimirLaudoAtivoPaciente,
                                                        command: () => parent.handleImprimirLaudo(pedido)
                                                    },
                                                    ...(pedido.CompartilharPortal && parent.state.isAcessoCompartilhado === false
                                                        ? [{
                                                            label: parent.state.labelBotaoCompartilhar || "Compartilhar",
                                                            icon: <img src={share} alt="Compartilhar" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                            disabled: btnLaudoDisabled,
                                                            visible: isPerfilMedico
                                                                ? parent.state.botaoCompartilharAtivoMedico
                                                                : parent.state.botaoCompartilharAtivoPaciente,
                                                            command: () => parent.handleAbrirModalGenerica(pedido, "Compartilhar")
                                                        }]
                                                        : [])
                                                ]}
                                            />
                                        ) : (
                                            <Button
                                                className="BtnLaudo"
                                                icon="custom-icon"
                                                label={parent.state.labelBotaoLaudo || "Laudo"}
                                                iconpos="right"
                                                onClick={() => {
                                                    const isAndroid = /Android/i.test(navigator.userAgent);
                                                    if (isAndroid) {
                                                        parent.handleAbrirModalGenerica(pedido, "LaudoAndroid");
                                                    } else {
                                                        parent.handleAbrirModalGenerica(pedido, "Laudo");
                                                    }
                                                }}
                                                disabled={btnLaudoDisabled}
                                                tooltipOptions={{ position: "bottom" }}
                                                title={titleBtnLaudoDisabledSemServico}
                                            />
                                        )
                                    ) : null}
                                </div>
                            </div>

                            <div>
                                {(isPerfilMedico ? parent.state.botaoAnexosAtivoMedico : parent.state.botaoAnexosAtivoPaciente) && (
                                    <Button
                                        visible={!btnAnexoDisabled}
                                        className="btnAnexos"
                                        type="text"
                                        placeholder="Bottom"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip="Anexos"
                                        iconpos="right"
                                        label={parent.state.labelBotaoAnexos || "Anexos"}
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Anexos")}
                                    />
                                )}
                            </div>

                            <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() || btnImageDisable ? "none" : "block" }}>
                                {isPerfilMedico && parent.state.botaoParecerAtivoMedico && (
                                    <Button
                                        type="text"
                                        placeholder="Bottom"
                                        tooltipOptions={{ position: "bottom" }}
                                        tooltip="Parecer Médico"
                                        icon="custom-icon"
                                        iconpos="right"
                                        label={parent.state.labelBotaoParecer || "Parecer médico"}
                                        className="btnParecerMedico"
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Parecer")}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="StudyArea-Preview">
                        <div className="StudyPreview-tablet">
                            {pedido.imagemPreviewUrl ? (
                                <div className="StudyPreview-Image">
                                    <img
                                        src={pedido.imagemPreviewUrl}
                                        alt="Prévia do exame"
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                        onLoad={(e) => e.target.style.opacity = 1}
                                        style={{
                                            width: "150px",
                                            height: "160px",
                                            borderRadius: "15px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            opacity: 0,
                                            transition: "opacity 0.3s ease-in-out"
                                        }}
                                    />

                                    <div className="spinner-imagePrevew">
                                        <div className="spinner-preview" />
                                    </div>
                                </div>
                            ) : (
                                <div className="StudyPreview-ImgNotFound">
                                    <div className="StudyPreview-ImgNotFound-Img"> </div>
                                    <div className="StudyPreview-ImgNotFound-Txt">
                                        <p> Imagens ainda não </p>
                                        <p> estão disponíveis </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="StudyArea-Right">
                    <div className="StudyPreview">
                        {pedido.imagemPreviewUrl ? (
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt="Prévia do exame"
                                    onClick={() => parent.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "223px",
                                        height: "232px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        transition: "opacity 0.3s ease-in-out"
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        ) : (
                            <div className="StudyPreview-ImgNotFound">
                                <div className="StudyPreview-ImgNotFound-Img"> </div>
                                <div className="StudyPreview-ImgNotFound-Txt">
                                    <p> Imagens ainda não </p>
                                    <p> estão disponíveis </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Panel
                id={`panelLaudo-${pedido.Id}`}
                className={parent.state.panelVisible ? "p-col-8" : ""}
                style={{
                    visibility: parent.mobilecheck() || parent.state.panelVisible === false || parent.state.selectedPedido.Id !== pedido.Id ? "hidden" : "visible"
                }}
                header={<div>
                    <div>{pedido.Paciente.Nome}</div>
                    <div>
                        <Button
                            icon="pi pi-window-maximize"
                            onClick={e => parent.viewFullScreen(`panelLaudo-${pedido.Id}`)}
                            style={{
                                position: "absolute",
                                float: "right",
                                right: parent.state.isFullScreen ? "50px" : "82px",
                                marginTop: "-25px"
                            }}
                        />
                    </div>

                    <div>
                        <Button
                            icon="pi pi-times"
                            onClick={() => parent.closeModalFullScreen(`panelLaudo-${pedido.Id}`)}
                            style={{
                                position: "absolute",
                                float: "right",
                                right: parent.state.isFullScreen ? "7px" : "40px",
                                marginTop: "-25px"
                            }}
                        />
                    </div>
                </div>}
            >
                <div id={`divLaudo-${pedido.Id}`} style={{ height: parent.state.panelVisible ? "65vh" : "1px" }}></div>
            </Panel>
        </div>
    );
};

export default StudyCard;
